import type { SortingState } from "@tanstack/react-table";
import { LISTING_HEALTH_COLUMN_ID } from "shared/app/ListingHealth/constants";

/** Columns the units endpoint can order by; the rest only sort the page in the grid. */
const SERVER_SORTABLE_COLUMNS = new Set<string>([LISTING_HEALTH_COLUMN_ID]);

export const sortingFromSearch = (search: string): SortingState => {
  const params = new URLSearchParams(search);
  const orderBy = params.get("order_by");
  if (!orderBy || !SERVER_SORTABLE_COLUMNS.has(orderBy)) return [];
  return [{ id: orderBy, desc: params.get("order_direction") === "desc" }];
};

export const unitsSortParams = (sorting: SortingState) => {
  const [sort] = sorting;
  return {
    order_by:
      sort && SERVER_SORTABLE_COLUMNS.has(sort.id) ? sort.id : undefined,
    order_direction: sort?.desc ? "desc" : "asc"
  };
};
